{
  "title": "Safety criteria",
  "tabs": {
    "label": "Sections",
    "events": "Events",
    "settings": "Sound settings"
  },
  "levels": {
    "normal": "Normal",
    "m1": "M-1 (Potentially dangerous)",
    "m2": "M-2 (Pre-emergency)",
    "m1Full": "M-1 (Potentially dangerous) state",
    "m2Full": "M-2 (Pre-emergency) state"
  },
  "kpi": {
    "open": "Active events",
    "unacknowledged": "Unacknowledged",
    "m1": "M-1 events",
    "m2": "M-2 events",
    "unit": "{{count}}"
  },
  "filters": {
    "status": "Status",
    "level": "Level",
    "unack": "Unacknowledged only",
    "search": "Search",
    "total": "Total: {{count}}",
    "reset": "Reset filters"
  },
  "status": {
    "open": "Active",
    "closed": "Closed",
    "all": "All"
  },
  "level": {
    "all": "All levels",
    "m1": "M-1",
    "m2": "M-2"
  },
  "columns": {
    "level": "Level",
    "indicator": "Indicator",
    "device": "Device",
    "startedAt": "Started",
    "duration": "Duration",
    "peak": "Peak value",
    "threshold": "Threshold",
    "state": "Status",
    "ack": "Acknowledged by"
  },
  "state": {
    "open": "Active",
    "closed": "Closed",
    "endedAt": "Ended: {{time}}"
  },
  "ack": {
    "button": "Acknowledge",
    "done": "Event acknowledged",
    "at": "at {{time}}"
  },
  "duration": {
    "d": "{{count}} d",
    "h": "{{count}} h",
    "m": "{{count}} min",
    "running": "ongoing"
  },
  "empty": {
    "openTitle": "No active events",
    "openText": "All monitored indicators are within limits.",
    "title": "No events found",
    "text": "No events match the selected filters."
  },
  "settings": {
    "m1Title": "Criterion 1 sound",
    "m2Title": "Criterion 2 sound",
    "sound": "Choose the sound",
    "sounds": {
      "signal_deep": "Deep signal",
      "siren": "Siren"
    },
    "configure": "Configure the alert",
    "screenTitle": "{{level}} alert (on screen)",
    "screenText": "When off, the alert is not shown on screen",
    "playTitle": "{{level}} alert (sound)",
    "playText": "When off, no sound is played",
    "test": "Test",
    "repeat": "Repeat count",
    "repeatSuffix": "times",
    "duration": "Duration, seconds",
    "durationSuffix": "s",
    "repeatError": "A whole number from 1 to 100",
    "durationError": "A whole number from 1 to 3600",
    "save": "Save",
    "cancel": "Cancel",
    "saved": "Settings saved",
    "updatedBy": "Last changed by {{name}}, {{time}}",
    "hint": "The settings apply to every user of the site"
  },
  "bell": {
    "label": "Alerts",
    "count": "{{count}} unacknowledged event(s)"
  },
  "banner": {
    "region": "Active alerts",
    "title": "{{level}}: {{indicator}} — {{value}}",
    "started": "Started: {{time}}",
    "threshold": "Threshold: {{value}}",
    "view": "View",
    "ack": "Acknowledge",
    "close": "Close",
    "mute": "Mute",
    "enableSound": "Enable sound",
    "blocked": "The browser is blocking sound"
  },
  "error": {
    "load": "Could not load the data",
    "retry": "Try again",
    "generic": "Something went wrong"
  }
}
